import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  guestCheckout: (email, name, phone) => 
    api.post(`/auth/guest-checkout?email=${encodeURIComponent(email)}&name=${encodeURIComponent(name)}&phone=${encodeURIComponent(phone)}`),
};

//Sizes APIs
export const sizeApi = {
  getAll: () => api.get('/sizes'),
  getById: (id) => api.get(`/sizes/${id}`),
  create: (data) => api.post('/sizes', data),
  update: (id, data) => api.put(`/sizes/${id}`, data),
  delete: (id) => api.delete(`/sizes/${id}`),
};

//Colors APIs
export const colorApi = {
  getAll: () => api.get('/colors'),
  getById: (id) => api.get(`/colors/${id}`),
  create: (data) => api.post('/colors', data),
  update: (id, data) => api.put(`/colors/${id}`, data),
  delete: (id) => api.delete(`/colors/${id}`),
};

// Category APIs
export const categoryApi = {
  getAll: () => api.get('/categories'),
  getById: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  delete: (id) => api.delete(`/categories/${id}`),
};

// Product APIs
export const productApi = {
  getAll: (params = {}) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
};

// Flash Sale APIs
export const flashSaleApi = {
  getAll: (activeOnly = false) => api.get('/flash-sales', { params: { active_only: activeOnly } }),
  create: (data) => api.post('/flash-sales', data),
  delete: (id) => api.delete(`/flash-sales/${id}`),
};

// Order APIs
export const orderApi = {
  create: (data) => api.post('/orders', data),
  getAll: (params = {}) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  updateStatus: (id, orderStatus, paymentStatus) => 
    api.put(`/orders/${id}/status?order_status=${orderStatus}${paymentStatus ? `&payment_status=${paymentStatus}` : ''}`),
};

// M-Pesa APIs
export const mpesaApi = {
  initiateStkPush: (data) => api.post('/mpesa/stk-push', data),
};

// Admin APIs
export const adminApi = {
  getDashboard: () => api.get('/admin/dashboard'),
  getUsers: () => api.get('/admin/users'),
  updateUserRole: (userId, role) => api.put(`/admin/users/${userId}/role?role=${role}`),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
};

// Seed API
export const seedApi = {
  seed: () => api.post('/seed'),
};

export default api;
